module.exports = __webpack_public_path__ + "img/clients.ab2ce34a.svg";